import { z } from 'zod';

export const agencySchema = z.object({
  id: z.string(),
  name: z.string(),
  createdOn: z.string(),
  updatedOn: z.string(),
});
export type Agency = z.infer<typeof agencySchema>;
export const agencyPageSchema = z
  .object({
    content: z.array(agencySchema),
    totalElements: z.number().optional(),
    page: z.object({ totalElements: z.number() }).optional(),
  })
  .transform((page) => ({
    content: page.content,
    totalElements: page.totalElements ?? page.page?.totalElements ?? page.content.length,
  }));
export interface AgencyFilter {
  name: string;
  page: number;
  size: number;
}
export const agencyPageSizes = [10, 20, 50, 100] as const;

export const agencyBrandSchema = z.object({
  brandId: z.string(),
  name: z.string(),
  logoUrl: z.string().nullable(),
  industry: z.string().nullable(),
  agencyId: z.string().nullable(),
  agencyName: z.string().nullable(),
  assignedAt: z.string().nullable(),
});
export const agencyBrandsPageSchema = z
  .object({
    content: z.array(agencyBrandSchema),
    totalElements: z.number().optional(),
    page: z.object({ totalElements: z.number() }).optional(),
  })
  .transform((page) => ({
    content: page.content,
    totalElements: page.totalElements ?? page.page?.totalElements ?? page.content.length,
  }));
